module.exports = __webpack_public_path__ + "static/Blue Card-7abcddbc1c61fdc4e0f1ae86b940093b.png";